module.exports = __webpack_public_path__ + "img/HU.999ce0ba.svg";